import { InstanceCana } from "./agro.instance-cana.model";
import { UserCanaDTO } from "./agro.user-dto-cana.model";
import { AutorizacoesCanaDTO } from "./agro.autorizacoes-cana.model";

/**
 * Modelo Padrão de Usuário Logado.
 */
export class UserCanaModel {

    user: UserCanaDTO;
    locale: string;
    instance: InstanceCana;
    authorization?: Map<string, Array<AutorizacoesCanaDTO>>;
    applications?: Array<AutorizacoesCanaDTO>;

    constructor() { };
}